import { CheckinHistory } from './CheckinHistory';
export default CheckinHistory;